const closeUpsell = document.querySelector(".section-upsell--close");
const sectionUpsell = document.querySelector(".section-upsell-product");
const productSubmitBtns = document.querySelectorAll(".product-form__submit");
productSubmitBtns.forEach((submitBtn) => {
  submitBtn.addEventListener("click", () => {
    setTimeout(() => {
      sectionUpsell.classList.add('show-upsell');
    }, 6000);
  });
});

closeUpsell.addEventListener("click", () => {
  sectionUpsell.classList.remove('show-upsell');
});